import { setUsersSessionFailed, setUsersSessionPending, setUsersSessionSucceed } from '../../actions/usersSession';
import { registerWsSession } from '../../actions/wsSession';
import { TThunkAction } from '../../types/redux/thunk';
import { fetchUsersSession } from '../fetchUsersSession';

// Одна минута в секундах
const ONE_MINUTE = 60;

/**
 * Получить token сессии
 */
export const checkUsersSession = (): TThunkAction<Promise<void>> => async (dispatch, getState, context) => {
  const { logger } = context;
  const {
    session: { token },
  } = getState();

  const timezone = -(new Date().getTimezoneOffset() / ONE_MINUTE);

  dispatch(setUsersSessionPending());

  try {
    const session = await fetchUsersSession(context, { timezone });

    if (!session) {
      dispatch(setUsersSessionFailed());

      return;
    }

    dispatch(setUsersSessionSucceed(session));

    if (token?.sessionToken && token.sessionToken !== session.sessionToken) {
      await dispatch(registerWsSession());
    }
  } catch (error) {
    logger.error(error, {
      domain: 'src/shared/services/checkUsersSession/checkUsersSession.ts',
      message: 'Не удалось проверить токен сессии',
    });

    dispatch(setUsersSessionFailed());
  }
};
